(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire7c47"];
var parcelRegister = parcelRequire.register;
parcelRegister("ywp2f", function(module, exports) {

$parcel$export(module.exports, "initProductVariant", function () { return $067c4f9c4a34eea7$export$7818f449806d9d91; });
const $067c4f9c4a34eea7$export$7818f449806d9d91 = ()=>{
    const productVariants = document.querySelectorAll(".i-product-variant");
    const mediaQuery = window.matchMedia("(min-width: 1499px)");
    productVariants.forEach((variant)=>{
        const content = variant.querySelector(".i-product-variant__content");
        const container = variant.closest(".s-product-variants .container");
        const header = variant.querySelector(".i-product-variant__header");
        header?.addEventListener("click", ()=>{
            variant.classList.toggle("--open");
        });
        if (!container || !content) return;
        let prevWidth;
        const setWidth = (width, offset)=>{
            content.style.setProperty("width", `${width - offset}px`);
        };
        new ResizeObserver((changes)=>{
            for (const change of changes){
                if (change.contentRect.width === prevWidth) return;
                prevWidth = change.contentRect.width;
                if (mediaQuery.matches) setWidth(prevWidth, 16);
                else setWidth(prevWidth, 8);
            }
        }).observe(container);
    });
};
$067c4f9c4a34eea7$export$7818f449806d9d91();

});

})();
//# sourceMappingURL=product-variant-item.ab1421ed.js.map
